import * as React from "react";

import { cn } from "@/lib/utils";

/** shadcn/ui Label — native-element variant (the studio doesn't ship
 * `@radix-ui/react-label`; a plain <label> carries the same semantics and
 * keeps the dependency surface unchanged). */
const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      "text-sm font-medium leading-none text-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className,
    )}
    {...props}
  />
));
Label.displayName = "Label";

export { Label };
